module.exports = __webpack_public_path__ + "static/media/logged-in-user.1d9378e6.svg";